/*
 * Search Messages
 *
 * This contains all the text for the Search component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  search: {
    id: 'app.components.Tags.Input.search',
    defaultMessage: 'Search',
  },
});
